// src/data/campaigns.ts

import type { Campaign } from "@/types";

export const CAMPAIGNS: Campaign[] = [
  {
    id:               "cmp-001",
    name:             "DeWalt Q2 Power Tools — Display",
    advertiser:       "DeWalt Tools",
    advertiserId:     "org-dewalt",
    objective:        "conversion",
    status:           "active",
    channels:         ["display", "oo"],
    budget:           480_000,
    spent:            312_400,
    impressions:      18_240_000,
    clicks:           321_000,
    conversions:      12_840,
    roas:             5.2,
    startDate:        "2026-02-01",
    endDate:          "2026-04-30",
    audienceSize:     840_000,
    attributionModel: "data_driven",
  },
  {
    id:               "cmp-002",
    name:             "DeWalt Pro Contractor — CTV",
    advertiser:       "DeWalt Tools",
    advertiserId:     "org-dewalt",
    objective:        "awareness",
    status:           "active",
    channels:         ["ctv", "video"],
    budget:           320_000,
    spent:            198_000,
    impressions:      22_100_000,
    clicks:           184_000,
    conversions:      7_240,
    roas:             4.1,
    startDate:        "2026-02-15",
    endDate:          "2026-05-15",
    audienceSize:     1_200_000,
    attributionModel: "time_decay",
  },
  {
    id:               "cmp-003",
    name:             "DeWalt Spring Sale — Retargeting",
    advertiser:       "DeWalt Tools",
    advertiserId:     "org-dewalt",
    objective:        "conversion",
    status:           "draft",
    channels:         ["display"],
    budget:           120_000,
    spent:            0,
    impressions:      0,
    clicks:           0,
    conversions:      0,
    roas:             0,
    startDate:        "2026-04-01",
    endDate:          "2026-04-30",
    audienceSize:     220_000,
    attributionModel: "last_touch",
  },
  {
    id:               "cmp-004",
    name:             "Kraft Mac & Cheese — Family Targeting",
    advertiser:       "Kraft Heinz",
    advertiserId:     "org-kraft",
    objective:        "consideration",
    status:           "active",
    channels:         ["oo", "display", "video"],
    budget:           840_000,
    spent:            621_000,
    impressions:      48_400_000,
    clicks:           726_000,
    conversions:      58_200,
    roas:             6.8,
    startDate:        "2026-01-15",
    endDate:          "2026-04-15",
    audienceSize:     3_400_000,
    attributionModel: "data_driven",
  },
  {
    id:               "cmp-005",
    name:             "Heinz Ketchup — Grocery Loyalists",
    advertiser:       "Kraft Heinz",
    advertiserId:     "org-kraft",
    objective:        "retention",
    status:           "active",
    channels:         ["oo", "display"],
    budget:           560_000,
    spent:            410_000,
    impressions:      32_100_000,
    clicks:           482_000,
    conversions:      42_100,
    roas:             5.9,
    startDate:        "2026-02-01",
    endDate:          "2026-05-01",
    audienceSize:     2_100_000,
    attributionModel: "linear",
  },
  {
    id:               "cmp-006",
    name:             "Kraft Singles — New Mover Conquest",
    advertiser:       "Kraft Heinz",
    advertiserId:     "org-kraft",
    objective:        "conversion",
    status:           "active",
    channels:         ["display", "ctv"],
    budget:           420_000,
    spent:            287_000,
    impressions:      21_800_000,
    clicks:           328_000,
    conversions:      28_400,
    roas:             6.1,
    startDate:        "2026-02-15",
    endDate:          "2026-05-15",
    audienceSize:     980_000,
    attributionModel: "data_driven",
  },
  {
    id:               "cmp-007",
    name:             "Nike Air Max — Spring Launch",
    advertiser:       "Nike",
    advertiserId:     "org-nike",
    objective:        "awareness",
    status:           "active",
    channels:         ["ctv", "video", "oo"],
    budget:           980_000,
    spent:            712_000,
    impressions:      54_200_000,
    clicks:           814_000,
    conversions:      38_400,
    roas:             5.6,
    startDate:        "2026-02-01",
    endDate:          "2026-05-31",
    audienceSize:     2_800_000,
    attributionModel: "time_decay",
  },
  {
    id:               "cmp-008",
    name:             "Nike Training — Athletic Enthusiasts",
    advertiser:       "Nike",
    advertiserId:     "org-nike",
    objective:        "conversion",
    status:           "paused",
    channels:         ["display", "video"],
    budget:           420_000,
    spent:            198_000,
    impressions:      14_200_000,
    clicks:           248_000,
    conversions:      14_200,
    roas:             4.8,
    startDate:        "2026-01-15",
    endDate:          "2026-04-15",
    audienceSize:     640_000,
    attributionModel: "data_driven",
  },
  {
    id:               "cmp-009",
    name:             "Samsung Galaxy S26 — Launch",
    advertiser:       "Samsung Electronics",
    advertiserId:     "org-samsung",
    objective:        "awareness",
    status:           "active",
    channels:         ["ctv", "video", "display", "oo"],
    budget:           2_400_000,
    spent:            1_840_000,
    impressions:      124_000_000,
    clicks:           1_612_000,
    conversions:      52_400,
    roas:             7.4,
    startDate:        "2026-01-01",
    endDate:          "2026-06-30",
    audienceSize:     8_400_000,
    attributionModel: "data_driven",
  },
  {
    id:               "cmp-010",
    name:             "Samsung QLED TV — Home Upgrade",
    advertiser:       "Samsung Electronics",
    advertiserId:     "org-samsung",
    objective:        "conversion",
    status:           "active",
    channels:         ["ctv", "display"],
    budget:           840_000,
    spent:            612_000,
    impressions:      42_100_000,
    clicks:           548_000,
    conversions:      18_400,
    roas:             6.8,
    startDate:        "2026-02-01",
    endDate:          "2026-05-31",
    audienceSize:     1_840_000,
    attributionModel: "time_decay",
  },
  {
    id:               "cmp-011",
    name:             "P&G Tide — Household Essentials",
    advertiser:       "Procter & Gamble",
    advertiserId:     "org-pgco",
    objective:        "retention",
    status:           "active",
    channels:         ["oo", "display"],
    budget:           980_000,
    spent:            812_000,
    impressions:      68_400_000,
    clicks:           820_000,
    conversions:      98_400,
    roas:             8.6,
    startDate:        "2026-01-01",
    endDate:          "2026-06-30",
    audienceSize:     4_200_000,
    attributionModel: "data_driven",
  },
  {
    id:               "cmp-012",
    name:             "P&G Pampers — New Parent Targeting",
    advertiser:       "Procter & Gamble",
    advertiserId:     "org-pgco",
    objective:        "conversion",
    status:           "active",
    channels:         ["display", "video", "ctv"],
    budget:           720_000,
    spent:            498_000,
    impressions:      42_000_000,
    clicks:           588_000,
    conversions:      72_400,
    roas:             9.1,
    startDate:        "2026-02-01",
    endDate:          "2026-05-31",
    audienceSize:     1_240_000,
    attributionModel: "data_driven",
  },
];

// ── Attribution journey data ───────────────────────────────────
export interface AttributionPath {
  campaignId: string;
  paths: {
    sequence:    string[];
    conversions: number;
    revenue:     number;
    pct:         number;
  }[];
}

export const ATTRIBUTION_PATHS: AttributionPath[] = [
  {
    campaignId: "cmp-001",
    paths: [
      { sequence: ["CTV", "Display", "O&O"],    conversions: 4_812, revenue: 481_200, pct: 37.5 },
      { sequence: ["Display", "O&O"],           conversions: 3_204, revenue: 320_400, pct: 24.9 },
      { sequence: ["O&O"],                      conversions: 2_568, revenue: 256_800, pct: 20.0 },
      { sequence: ["Display"],                  conversions: 1_284, revenue: 128_400, pct: 10.0 },
      { sequence: ["CTV", "Display"],           conversions:   972, revenue:  97_200, pct:  7.6 },
    ],
  },
  {
    campaignId: "cmp-009",
    paths: [
      { sequence: ["CTV", "Video", "Display", "O&O"], conversions: 18_340, revenue: 2_201_000, pct: 35.0 },
      { sequence: ["CTV", "Display"],                 conversions: 12_576, revenue: 1_509_000, pct: 24.0 },
      { sequence: ["Video", "Display"],               conversions:  9_432, revenue: 1_132_000, pct: 18.0 },
      { sequence: ["Display", "O&O"],                 conversions:  7_860, revenue:   943_000, pct: 15.0 },
      { sequence: ["CTV"],                            conversions:  4_192, revenue:   503_000, pct:  8.0 },
    ],
  },
];

// ── Incrementality results ────────────────────────────────────
export interface IncrementalityResult {
  campaignId:       string;
  campaignName:     string;
  exposedConvRate:  number;
  controlConvRate:  number;
  lift:             number;
  confidenceLevel:  number;
  incrementalConversions: number;
  incrementalRevenue:     number;
  holdoutPct:       number;
}

export const INCREMENTALITY_RESULTS: IncrementalityResult[] = [
  {
    campaignId:             "cmp-001",
    campaignName:           "DeWalt Q2 Power Tools — Display",
    exposedConvRate:        3.84,
    controlConvRate:        1.12,
    lift:                   242.9,
    confidenceLevel:        97.4,
    incrementalConversions: 9_012,
    incrementalRevenue:     901_200,
    holdoutPct:             10,
  },
  {
    campaignId:             "cmp-004",
    campaignName:           "Kraft Mac & Cheese — Family Targeting",
    exposedConvRate:        4.21,
    controlConvRate:        1.84,
    lift:                   128.8,
    confidenceLevel:        95.1,
    incrementalConversions: 24_640,
    incrementalRevenue:     1_232_000,
    holdoutPct:             10,
  },
  {
    campaignId:             "cmp-009",
    campaignName:           "Samsung Galaxy S26 — Launch",
    exposedConvRate:        2.14,
    controlConvRate:        0.48,
    lift:                   345.8,
    confidenceLevel:        99.2,
    incrementalConversions: 36_680,
    incrementalRevenue:     7_336_000,
    holdoutPct:             10,
  },
  {
    campaignId:             "cmp-011",
    campaignName:           "P&G Tide — Household Essentials",
    exposedConvRate:        5.84,
    controlConvRate:        3.12,
    lift:                   87.2,
    confidenceLevel:        96.8,
    incrementalConversions: 44_800,
    incrementalRevenue:     2_240_000,
    holdoutPct:             10,
  },
];